/* eslint-disable no-else-return */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IconX } from '../../Icons';
import { HostProvider } from '../../utils/HostProvider';

interface Props {
  visible: boolean;
  promocion: boolean;
  setVisible: (visible: boolean) => void;
  setPromocion: (visible: boolean) => void;
}

const CondLegalesModal: FC<Props> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,react-hooks/rules-of-hooks
  const { t } = useTranslation();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { visible, setVisible, promocion, setPromocion } = props;
  const isCaprabo = HostProvider.isCaprabo();
  const isErosky = HostProvider.isEroski();
  let titulo = t('vales.condiciones-legales-titulo');

  let listaCondicionesLegales: string[] = [
    t('vales.condiciones-legales-l1'),
    t('vales.condiciones-legales-l2'),
    t('vales.condiciones-legales-l3'),
    t('vales.condiciones-legales-l4'),
    t('vales.condiciones-legales-l5'),
    t('vales.condiciones-legales-l6'),
  ];

  if (isErosky && !promocion) {
    listaCondicionesLegales = [
      t('vales.condiciones-legales-l1'),
      t('vales.condiciones-legales-l2'),
      t('vales.condiciones-legales-l3'),
      t('vales.condiciones-legales-l4'),
      t('vales.condiciones-legales-l5'),
      t('vales.condiciones-legales-l6'),
    ];
  }

  if (isErosky && promocion) {
    listaCondicionesLegales = [
      t('vales.condiciones-legales-promocion-l1'),
      t('vales.condiciones-legales-promocion-l2'),
      t('vales.condiciones-legales-promocion-l3'),
      t('vales.condiciones-legales-promocion-l4'),
    ];
  }

  if (isCaprabo && !promocion) {
    titulo = t('caprabo.cupones.condiciones-legales-titulo');
    listaCondicionesLegales = [
      t('caprabo.cupones.condiciones-legales-l1'),
      t('caprabo.cupones.condiciones-legales-l2'),
      t('caprabo.cupones.condiciones-legales-l3'),
      t('caprabo.cupones.condiciones-legales-l4'),
      t('caprabo.cupones.condiciones-legales-l5'),
      t('caprabo.cupones.condiciones-legales-l6'),
      t('caprabo.cupones.condiciones-legales-l7'),
      t('caprabo.cupones.condiciones-legales-l8'),
    ];
  }

  if (isCaprabo && promocion) {
    titulo = t('caprabo.cupones.condiciones-legales-titulo');
    listaCondicionesLegales = [
      t('caprabo.cupones.condiciones-legales-promocion-l1'),
      t('caprabo.cupones.condiciones-legales-promocion-l2'),
      t('caprabo.cupones.condiciones-legales-promocion-l3'),
      t('caprabo.cupones.condiciones-legales-promocion-l4'),
      t('caprabo.cupones.condiciones-legales-promocion-l5'),
      t('caprabo.cupones.condiciones-legales-promocion-l6'),
      t('caprabo.cupones.condiciones-legales-promocion-l7'),
    ];
  }

  return (
    <>
      {(() => {
        return (
          <>
            <div
              className={`modal modal--large ${visible ? 'is-active' : ''}`}
              id="modal-legal"
            >
              <div className="modal__background" />
              <div className="modal__card">
                <header className="modal__card-head u-flex">
                  <div className="modal__card-title">{titulo}</div>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    href="#legal-conditions"
                    className="modal__card-close modal-cerrar"
                  >
                    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                    <div
                      className="icon icon-medium icon--close"
                      onClick={() => {
                        setPromocion(false);
                        setVisible(false);
                      }}
                    >
                      <IconX classCss="" />
                    </div>
                  </a>
                </header>
                <section className="modal__card-body">
                  <ol className="condiciones_legales_ol">
                    <p>
                      <>
                        {listaCondicionesLegales.map((avisoCondicionLegal) => (
                          <li>- {t(avisoCondicionLegal)}</li>
                        ))}
                      </>
                    </p>
                  </ol>
                  <div className="modal__botonera">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                    <a
                      className="btn btn-primary"
                      onClick={() => setVisible(false)}
                    >
                      {t('entendido')}
                    </a>
                  </div>
                </section>
              </div>
            </div>
          </>
        );
      })()}
    </>
  );
};

export default CondLegalesModal;
